import React from 'react';
import { Form, Input, Button, Card, message, Divider, Space } from 'antd';
import { UserOutlined, LockOutlined, GoogleOutlined, WindowsOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import BackgroundAnimation from '../components/BackgroundAnimation';
import '../styles/LoginPage.css';
import logo from '../assets/logo.png';

interface LoginFormData {
  username: string;
  password: string;
}

const LoginPage: React.FC = () => {
  const [form] = Form.useForm();
  const onFinish = (values: LoginFormData) => {
    console.log('Login form submitted:', values);
    message.success('Login successful!');
    form.resetFields();
    localStorage.setItem('isAuthenticated', 'true');
    navigate('/shipsy/home');
  };

  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    console.log('Google login clicked');
    message.success('Google login simulation successful!');
    localStorage.setItem('isAuthenticated', 'true');
    navigate('/shipsy/home');
  };

  const handleAzureLogin = () => {
    console.log('Azure login clicked');
    message.success('Azure login simulation successful!');
    localStorage.setItem('isAuthenticated', 'true');
    navigate('/shipsy/home');
  };

  return (
    <div className="login-container">
      <BackgroundAnimation />
      <Card className="login-card">
        <div className="login-header">
          <img src={logo} alt="100xBI Logo" className="login-logo" />
          <h1>Welcome to 100xBI</h1>
          <p>Sign in to continue to your dashboard</p>
        </div>

        <div className="social-login">
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Button
              icon={<GoogleOutlined />}
              onClick={handleGoogleLogin}
              size="large"
              block
              className="google-btn"
            >
              Continue with Google
            </Button>
            <Button
              icon={<WindowsOutlined />}
              onClick={handleAzureLogin}
              size="large"
              block
              className="azure-btn"
            >
              Continue with Azure
            </Button>
          </Space>
        </div>

        <Divider plain>Or sign in with email</Divider>

        <Form
          form={form}
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          layout="vertical"
          className="login-form"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Username"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large">
              Sign in with Email
            </Button>
          </Form.Item>
        </Form>

        <div className="login-footer">
          <p>Don't have an account? <a href="#">Sign up</a></p>
          <p><a href="#">Forgot password?</a></p>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
